import { GameEvents } from '../GameEvents';
import type EventBus from '../EventBus';

export default class MenuHandler {
  private state: any;
  private slice: any;
  private eventBus: EventBus;

  constructor(state: any, slice: any, eventBus: EventBus) {
    this.state = state;
    this.slice = slice;
    this.eventBus = eventBus;

    this.eventBus.on(GameEvents.RETURN_TO_HOME, () => this._onReturnToHome());
    this.eventBus.on(GameEvents.RESET_PROGRESS, () => this._onResetProgress());
    this.eventBus.on(GameEvents.START_SANDBOX, () => this._onStartSandbox());
  }

  _onReturnToHome() {
    this.eventBus.emit(GameEvents.SET_SCREEN, 'home');
  }

  _onResetProgress() {
    this.eventBus.emit(GameEvents.CLEAR_PROGRESS);
    this.eventBus.emit(GameEvents.SET_SCREEN, 'home');
  }

  _onStartSandbox() {
    this.eventBus.emit(GameEvents.PLAY_LEVEL, { levelKey: 'sandbox' });
  }
}
